import { render, staticRenderFns } from "./guest-list.vue?vue&type=template&id=6f4afcc2&"
import script from "./guest-list.vue?vue&type=script&lang=ts&"
export * from "./guest-list.vue?vue&type=script&lang=ts&"
import style0 from "./guest-list.vue?vue&type=style&index=0&id=6f4afcc2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports